const styles = {
  header: {
    fontWeight: 700,
    letterSpacing: ".3rem",
    color: "inherit",
    textDecoration: "none",
  },
  page: {
    my: 0.5,
    color: "white",
    fontSize: 12,
  },
  pageBox: {
    direction: "row",
    display: "flex",
    justifyContent: "flex-end",
  },
};

export default styles;
